// extracted by mini-css-extract-plugin
module.exports = {"root":"_25DnI","text":"_1nbd7","icon":"D47GA"};